import { Space as _Space, SpaceProps as _SpaceProps } from 'antd'

type SpaceProps = _SpaceProps

export function Space(props: SpaceProps) {
  return <_Space {...props} />
}
